import React from "react";
import styles from "../../pages/JobDetails/Jobdetails.module.css";
import DynamicTable from "@atlaskit/dynamic-table";
import Pagination from "@atlaskit/pagination";
import { createCells, createHead } from "./BackupIssuesTableHandler";
const TableWrapper = ({ children }) => (
  <div className={styles.tableWrapperStyles}>{children}</div>
);
const BackupIssueJobDetails = ({
  moreJobDetails,
  isLoading,
  totalPages,
  pagination,
  onPaginationChange,
}) => {
  const head = createHead(true);
  const rows = createCells(moreJobDetails);

  return (
    <div className={styles.tablecontainer}>
      <TableWrapper>
        <DynamicTable
          head={head}
          rows={rows}
          rowsPerPage={undefined}
          defaultPage={1}
          loadingSpinnerSize="large"
          isLoading={isLoading}
          emptyView={<strong>No data found</strong>}
        />
      </TableWrapper>
      {totalPages !== 0 ? (
        <div className={styles.pagination}>
          <Pagination
            pages={Array.from({
              length: Math.ceil(totalPages / pagination.size),
            }).map((currentElement, i) => i + 1)}
            onChange={onPaginationChange}
            selectedIndex={pagination.page - 1}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default BackupIssueJobDetails;
